import logger from '~/shared/utils/logger'

export type DateStrings = {
  jsDate: Date
  monthDay: string
  monthDayYear: string
  dayMonthYear: string
  year: number
}

export type DateListFlags = {
  isNew: boolean
  isUpdated: boolean
}


export const dateStrings = (input: string | Date): DateStrings => {
  let date_created: Date

  try {
    date_created = new Date(input)
  } catch (error) {
    throw new TypeError(`dateStrings: unable to parse date input: ${String(input)}`, {
      cause: error,
    })
  }

  if (Number.isNaN(date_created.getTime())) {
    throw new TypeError(`dateStrings: invalid date input: ${String(input)}`)
  }

  const year = date_created.getFullYear()
  const month = date_created.getMonth() + 1
  const pMonth = month.toString().padStart(2,"0");
  const day = date_created.getDate()
  const pDay = day.toString().padStart(2,"0");
  return({
    jsDate: date_created,
    monthDay: `${pMonth}-${pDay}`,
    monthDayYear: `${pMonth}-${pDay}-${year}`,
    dayMonthYear: `${pDay}-${pMonth}-${year}`,
    year: year
  })
}

export const normalizeDates = <T extends {
  date_created?: string | null
  date_modified?: string | null
  path?: string
  title?: string
}>(
  item: T,
  referenceDate: Date = new Date()
): T & DateStrings & DateListFlags => {
  const normalized = { ...item }

  if (!normalized.date_created) {
    normalized.date_created = referenceDate.toLocaleDateString('en-CA')
    logger.warn(`normalizeDates: "${normalized.path} ${normalized.title}" is missing date_created. Defaulting to ${normalized.date_created}.`)
  }

  if (!normalized.date_modified) {
    normalized.date_modified = normalized.date_created
  }

  if ((normalized.date_modified ?? '') < (normalized.date_created ?? '')) {
    logger.warn(`normalizeDates: "${normalized.path} ${normalized.title}" has date_modified earlier than date_created: date_modified: ${normalized.date_modified} date_created: ${normalized.date_created}. Adjusting date_modified to match date_created.`)
    normalized.date_modified = normalized.date_created
  }

  const ds = dateStrings(normalized.date_modified!)

  const sixMonthsAgo = new Date(referenceDate)
  sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6)

  const isUpdated = (normalized.date_modified ?? '') > (normalized.date_created ?? '')
  const isNew = isUpdated && ds.jsDate > sixMonthsAgo

  return { ...normalized, ...ds, isNew, isUpdated }
}
